export const getDate = ( value: string | number | undefined ): Date | undefined => {
    if ( typeof value === 'string' && !isNaN( Date.parse( value ) ) ) {
        return new Date( value );
    } else if ( typeof value === 'number' ) {
        return new Date( value );
    } else {
        return undefined;
    }
};
